import { SuggestedAddressRules } from "./suggested-address-rules.abstract";

export class DefaultRulesService extends SuggestedAddressRules {
  icon = "/assets/images/tcb/house-red.svg";
}
